/* Polsk katalog for locale-no.js (del 1 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'common.save': 'Zapisz zmiany',
  'common.saving': 'Zapisywanie...',
  'common.cancel': 'Anuluj',
  'common.hoursMinutes': '{h} godz. {m} min',
  'common.delete': 'Usuń',
  'common.confirmTitle': 'Na pewno?',
  'common.continue': 'Dalej',
  'account.view': 'Widok kont',
  'account.relevant': 'Istotne',
  'account.all': 'Wszystkie',
  'account.favorites': 'Ulubione',
  'account.addFavorite': 'Dodaj do ulubionych',
  'account.removeFavorite': 'Usuń z ulubionych',
  'account.searchHint': 'Szukaj po nazwie, numerze lub np. 5x',
  'common.working': 'Przetwarzanie...',
  'common.close': 'Zamknij',
  'common.on': 'Wł.',
  'common.off': 'Wył.',
  'common.active': 'Aktywny',
  'common.yes': 'Tak',
  'common.no': 'Nie',
  'month.short.1': 'Sty',
  'month.short.2': 'Lut',
  'month.short.3': 'Mar',
  'month.short.4': 'Kwi',
  'month.short.5': 'Maj',
  'month.short.6': 'Cze',
  'month.short.7': 'Lip',
  'month.short.8': 'Sie',
  'month.short.9': 'Wrz',
  'month.short.10': 'Paź',
  'month.short.11': 'Lis',
  'month.short.12': 'Gru',
  'ui.summary.title': 'Podsumowanie',
  'ui.summary.exVat': 'Suma bez VAT',
  'ui.summary.vat': 'VAT',
  'ui.summary.total': 'Suma całkowita',
  'ui.more': 'Więcej',
  'ui.filter': 'Filtr',
  'ui.filterReset': 'Wyczyść filtr',
  'ui.filterChoices': 'Opcje filtra',
  'ui.period': 'Okres',
  'ui.from': 'Od',
  'ui.to': 'Do',
  'ui.fromMonth': 'Od miesiąca',
  'ui.toMonth': 'Do miesiąca',
  'ui.fromDate': 'Od daty',
  'ui.toDate': 'Do daty',
  'ui.today': 'Dziś',
  'ui.wholeYearTitle': 'Cały rok {year}',
  'ui.quick.wholeYear': 'Cały rok',
  'ui.quick.ytd': 'Od początku roku',
  'ui.quick.thisTerm': 'Bieżący okres',
  'ui.quick.lastYear': 'Poprzedni rok',
  'ui.term': 'Okres {n}',
  'ui.amountSearch': 'Szukaj po kwocie',
  'ui.amountFrom': 'Kwota od',
  'ui.amountTo': 'Kwota do',
  'list.search': 'Szukaj',
  'list.copy': 'Kopiuj',
  'list.copied': 'Skopiowano: {text}',
  'list.export': 'Eksportuj',
  'list.download': 'Pobierz',
  'list.downloaded': 'Pobrano: {label}',
  'list.nothingToExport': 'Brak wierszy do eksportu',
  'list.downloading': 'Pobieranie: {label} …',
  'list.upload': 'Prześlij',
  'list.add': 'Dodaj',
  'list.archiveTitle': 'Przenieść do archiwum?',
  'list.archiveConfirm': 'Przenieś do archiwum',
  'list.deleteTitle': 'Usunąć?',
  'list.delete': 'Usuń',
  'list.archiveBody': 'Czy chcesz przenieść {name} do archiwum? Klient zostanie ukryty na listach aktywnych klientów, ale faktury, płatności i historia zostaną zachowane. Tej operacji nie można cofnąć z tego miejsca.',
  'list.deleteBody': 'Czy na pewno chcesz usunąć {name}? Tej operacji nie można cofnąć.',
  'crm.prospect': 'Potencjalny klient',
  'crm.active': 'Aktywny',
  'crm.quoteSent': 'Oferta wysłana',
  'crm.pause': 'Wstrzymany',
  'badge.paid': 'Rozliczona',
  'badge.active': 'Aktywny',
  'badge.sent': 'Wysłana',
  'badge.draft': 'Szkic',
  'badge.created': 'Niewysłana',
  'badge.overdue': 'Przeterminowana',
  'badge.credited': 'Skorygowana',
  'badge.inactive': 'Nieaktywny',
  'badge.ok': 'Złożono',
  'badge.no': 'Nie złożono',
  'badge.soon': 'Wkrótce termin',
  'status.draft': 'Szkic',
  'status.created': 'Niewysłana',
  'status.sent': 'Wysłana',
  'status.paid': 'Zapłacona',
  'status.overdue': 'Przeterminowana',
  'status.credited': 'Skorygowana',
  'app.loading': 'Wczytywanie Twojej księgowości…',
  'app.loadingPersonalFinance': 'Wczytywanie Twoich finansów osobistych…',
  'app.loadingEmployeePortal': 'Wczytywanie Twojego portalu pracownika…',
  'project.cost.field': 'Projekt',
  'project.cost.none': 'Bez projektu',
  'project.cost.billable': 'Refakturowane na klienta',
  'project.cost.pickTitle': 'Wybierz projekt',
  'project.cost.search': 'Szukaj projektu lub klienta',
  'project.cost.searchEmpty': 'Żaden projekt nie pasuje do wyszukiwania.',
  'project.cost.toProject': 'Do projektu',
  'app.employeePortalVerifyTitle': 'Potwierdź swój adres e-mail',
  'app.employeePortalVerifyText': 'Wysłaliśmy link potwierdzający na adres {{email}}. Może minąć kilka minut, zanim dotrze. Sprawdź też folder spam. Otwórz link, aby kontynuować.',
  'app.employeePortalVerifyResend': 'Wyślij link ponownie',
  'app.employeePortalVerifySent': 'Link potwierdzający został wysłany ponownie.',
  'app.employeePortalVerifyAlready': 'Adres e-mail jest już potwierdzony. Odśwież stronę.',
  'app.employeePortalVerifyFailed': 'Nie udało się wysłać linku potwierdzającego.',
  'app.emailVerifyCheck': 'Potwierdziłem',
  'app.emailVerifyConfirmed': 'Adres e-mail został potwierdzony.',
  'app.emailVerifyNotConfirmed': 'Adres e-mail nie został jeszcze potwierdzony. Otwórz link w wiadomości e-mail i spróbuj ponownie.',
  'app.emailVerifyCheckFailed': 'Nie udało się sprawdzić adresu e-mail.',
  'app.emailVerifyInitialFailed': 'Konto zostało utworzone, ale nie udało się wysłać linku potwierdzającego. Spróbuj wysłać go ponownie.',
  'app.placeholder.title': 'Ta strona jest w drodze',
  'app.placeholder.text': 'Dopracowujemy tu ostatnie szczegóły. Zajrzyj wkrótce!',
  'app.nobusiness.title': 'Od czego chcesz zacząć?',
  'app.nobusiness.text': 'Jesteś zalogowany, ale nie masz jeszcze firmy w Plumme.',
  'app.nobusiness.create': 'Utwórz firmę',
  'app.nobusiness.signOut': 'Wyloguj się',
  'common.signOut': 'Wyloguj się',
  'auth.sub.default': 'Prosta księgowość dla małych firm',
  'auth.sub.forgot': 'Zresetuj hasło',
  'auth.sub.sent': 'Sprawdź swoją pocztę',
  'auth.sub.signup': 'Utwórz konto i skonfiguruj firmę',
  'auth.language': 'Język',
  'auth.invite.household': 'Otrzymałeś zaproszenie do finansów domowych. Zaloguj się lub utwórz konto przy użyciu adresu e-mail, na który wysłano zaproszenie.',
  'auth.invite.business': 'Otrzymałeś zaproszenie klienta. Wpisz adres e-mail, na który wysłano zaproszenie, a otworzymy je po zalogowaniu.',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'ty@przyklad.pl',
  'auth.password': 'Hasło',
  'auth.name': 'Imię i nazwisko',
  'auth.namePlaceholder': 'Twoje imię i nazwisko',
  'auth.passwordMin': 'Co najmniej 6 znaków',
  'auth.showPassword': 'Pokaż hasło',
  'auth.hidePassword': 'Ukryj hasło',
  'auth.remember': 'Zapamiętaj mnie',
  'auth.forgot': 'Nie pamiętasz hasła?',
  'auth.signIn': 'Zaloguj się',
  'auth.signingIn': 'Logowanie...',
  'auth.noAccount': 'Nie masz konta?',
  'auth.createAccount': 'Utwórz konto',
  'auth.creating': 'Tworzenie...',
  'auth.backToLogin': 'Wróć do logowania',
  'auth.forgotCopy': 'Wpisz adres e-mail, którym się logujesz, a wyślemy Ci link do utworzenia nowego hasła.',
  'auth.sendResetLink': 'Wyślij link resetujący',
  'auth.sending': 'Wysyłanie...',
  'auth.sentCopy': 'Wysłaliśmy link na adres {email}. Kliknij link w wiadomości, aby utworzyć nowe hasło.',
  'auth.wrongEmail': 'Błędny adres e-mail? Spróbuj ponownie',
  'auth.error.signIn': 'Logowanie nie powiodło się.',
  'auth.error.reset': 'Nie udało się wysłać linku resetującego.',
  'auth.error.signUp': 'Nie udało się utworzyć konta.',
  'capture.scan': 'Zeskanuj dokument',
  'capture.toInbox': 'Do skrzynki odbiorczej',
  'capture.toPurchase': 'Do Opłacony zakup',
  'capture.analysisFailed': 'Dokument został przesłany, ale analiza się nie powiodła.',
  'capture.readyInPurchase': 'Dokument jest gotowy w Opłacony zakup.',
  'capture.uploadingToInbox': 'Przesyłanie dokumentu do skrzynki odbiorczej ...',
  'capture.uploadedToInbox': 'Dokument przesłany do skrzynki odbiorczej.',
  'capture.uploadFailed': 'Nie udało się przesłać dokumentu.',
  'capture.analysisTimedOut': 'Dokument został przesłany. Analiza trwa nieco dłużej i jest kontynuowana w tle.',
  'capture.paymentDialogLoadFailed': 'Nie udało się wczytać opcji płatności. Spróbuj ponownie.',
  'nav.home': 'Start',
  'nav.aiBookkeeper': 'AI Księgowy',
  'nav.aiAdvisor': 'AI Doradca',
  'nav.newSale': 'Nowa sprzedaż',
  'nav.invoices': 'Lista faktur',
  'nav.otherSales': 'Inna sprzedaż',
  'nav.customers': 'Klienci',
  'nav.products': 'Produkty',
  'nav.projects': 'Projekty',
  'nav.subscriptions': 'Umowy',
  'nav.newPurchase': 'Nowy zakup',
  'nav.manualEntry': 'Księgowanie ręczne',
  'nav.suppliers': 'Dostawcy',
  'nav.assets': 'Środki trwałe',
  'nav.inventory': 'Magazyn',
  'nav.inbox': 'Skrzynka odbiorcza',
  'nav.incomeStatement': 'Rachunek zysków i strat',
  'nav.trialBalance': 'Zestawienie obrotów i sald',
  'nav.budget': 'Budżet',
  'nav.filings': 'MVA-melding',
  'nav.taxReturn': 'Skattemelding',
  'nav.yearEndClosing': 'Zamknięcie roku',
  'nav.annualAccounts': 'Sprawozdanie finansowe',
  'nav.payroll': 'Płace',
  'nav.mileageLog': 'Ewidencja przebiegu',
  'nav.vouchers': 'Transakcje',
  'nav.bank': 'Bank',
  'nav.myPage': 'Moja strona',
  'nav.activityLog': 'Dziennik aktywności',
  'nav.altinn': 'Altinn',
  'nav.settings': 'Ustawienia',
  'navgroup.sales': 'Sprzedaż',
  'navgroup.purchases': 'Zakupy',
  'navgroup.reports': 'Raporty',
  'navgroup.filings': 'Deklaracje',
  'navgroup.employees': 'Pracownicy',
  'navgroup.other': 'Inne',
  'navgroup.miscellaneous': 'Pozostałe',
  'navgroup.ai': 'AI',
  'navgroup.settings': 'Ustawienia',
  'navhelp.home': 'Twoja strona startowa – kluczowe wskaźniki, wykresy i skróty do rejestrowania sprzedaży i zakupów.',
  'navhelp.aiBookkeeper': 'SuperPlumma przegląda bank, dowody księgowe, VAT i terminy oraz przygotowuje propozycje. Sprawdzasz i zatwierdzasz, zanim cokolwiek zostanie zaksięgowane.',
  'navhelp.aiAdvisor': 'Doradztwo finansowe od SuperPlumma – wskaźnik kondycji, rekomendacje, prognoza przepływów pieniężnych, ryzyko i optymalizacja podatkowa.',
  'navhelp.newSale': 'Utwórz nową fakturę lub ofertę dla klienta. Sprzedaż jest księgowana automatycznie.',
  'navhelp.invoices': 'Przegląd wszystkich faktur i ofert – status, termin płatności i płatność.',
  'navhelp.customers': 'Twój rejestr klientów. Dodawaj i edytuj klientów, którym wystawiasz faktury.',
  'navhelp.products': 'Towary i usługi, które sprzedajesz, z ceną i stawką VAT – gotowe do użycia na fakturach.',
  'navhelp.projects': 'Rejestruj godziny na projektach i aktywnościach, śledź wykonaną pracę i zamieniaj niezafakturowane godziny w szkice faktur.',
  'navhelp.subscriptions': 'Subskrypcje, faktury cykliczne i listy klientów z kontrolą nad automatyczną wysyłką.',
  'navhelp.newPurchase': 'Zarejestruj zakup lub fakturę dostawcy z dowodem księgowym, dostawcą, kwotą i kontem.',
  'navhelp.manualEntry': 'Księguj ręcznie bezpośrednio na koncie, gdy potrzebujesz pełnej kontroli nad zapisem.',
  'navhelp.suppliers': 'Twój rejestr dostawców – nazwa, numer organizacyjny i numer rachunku do wypłat.',
  'navhelp.assets': 'Środki trwałe i trwałe wartości amortyzowane w czasie.',
  'navhelp.inventory': 'Inwentaryzacja i wartość Twoich zapasów. Udokumentuj liczenie i zaksięguj zmianę stanu.',
  'navhelp.inbox': 'Dokumenty, które wpłynęły, ale nie zostały jeszcze zaksięgowane. Przeciągnij je na właściwe księgowanie.',
  'navhelp.incomeStatement': 'Przychody minus koszty – pokazuje, czy firma osiąga zysk.',
  'navhelp.trialBalance': 'Salda wszystkich kont – podstawa Twoich raportów finansowych.',
  'navhelp.budget': 'Przygotuj budżet i śledź, jak wypadasz na tle celów.',
  'navhelp.filings': 'Sprawdź podstawę VAT dla każdego okresu. Samą deklarację składa się w Skatteetaten.',
  'navhelp.taxReturn': 'Wersja robocza skattemelding na podstawie ksiąg – sprawdź liczby przed złożeniem w Skatteetaten.',
  'navhelp.yearEndClosing': 'Krok po kroku przez wszystko, co trzeba zrobić, aby zamknąć rok obrotowy.',
  'navhelp.annualAccounts': 'Wynik, bilans, noty i podpisy. Sprawozdanie finansowe składa się w Regnskapsregisteret poza Plumme.',
  'navhelp.payroll': 'Uruchom listę płac, utwórz paski wynagrodzeń i zaksięguj wynagrodzenia. A-melding składa się poza Plumme.',
  'navhelp.mileageLog': 'Rejestruj przejazdy służbowe i sprawdzaj kilometry oraz odliczenia za rok.',
  'navhelp.vouchers': 'Pełny przegląd zaksięgowanych transakcji i powiązanych dokumentów – wyszukuj i odnajduj.',
  'navhelp.bank': 'Prześlij wyciągi bankowe i uzgodnij rachunki bankowe z księgami.',
  'navhelp.myPage': 'Twój profil i ustawienia użytkownika.',
  'navhelp.activityLog': 'Pełna historia tego, co zrobiono w księgowości, i przez kogo.',
  'navhelp.altinn': 'Skrót do zgłoszeń i korespondencji w Altinn.',
  'navhelp.settings': 'Ustawienia firmy, księgowości i aplikacji.',
  'navhelp.fallback': 'Otwórz {label}.',
  'route.home': 'Start',
  'route.newSale': 'Nowa sprzedaż',
  'route.newSaleliste': 'Lista faktur',
  'route.customers': 'Klienci',
  'route.products': 'Produkty',
  'route.projects': 'Projekty',
  'route.aiBookkeeper': 'AI Księgowy',
  'route.aiAdvisor': 'AI Doradca',
  'route.newPurchase': 'Opłacony zakup',
  'route.manualEntry': 'Dowolne księgowanie',
  'route.vouchers': 'Transakcje',
  'route.suppliers': 'Dostawcy',
  'route.assets': 'Środki trwałe',
  'route.filings': 'Zgłoszenia',
  'route.inbox': 'Skrzynka odbiorcza',
  'route.documentation': 'Dokumentacja',
  'route.mileageLog': 'Ewidencja przebiegu',
  'route.bank': 'Bank',
  'route.altinn': 'Altinn',
  'route.settings': 'Ustawienia',
  'route.otherSales': 'Inna sprzedaż',
  'route.subscriptions': 'Umowy',
  'route.incomeStatement': 'Rachunek zysków i strat',
  'route.trialBalance': 'Zestawienie obrotów i sald',
  'route.budget': 'Budżet',
  'route.payroll': 'Płace',
  'route.taxReturn': 'Skattemelding',
  'route.yearEndClosing': 'Zamknięcie roku',
  'route.annualAccounts': 'Sprawozdanie finansowe',
  'route.myPage': 'Moja strona',
  'route.employeePortal': 'Portal pracownika',
  'route.activityLog': 'Dziennik aktywności',
  'route.personalFinance': 'Finanse osobiste',
  'shell.openMenu': 'Otwórz menu',
  'shell.closeMenu': 'Zamknij menu',
  'shell.collapseMenu': 'Zwiń menu',
  'shell.showLabels': 'Pokaż etykiety menu',
  'shell.hideLabels': 'Ukryj etykiety menu',
  'shell.designSystem': 'System projektowy ↗',
  'shell.customizeMenu': 'Dostosuj menu',
  'shell.customizeHelpTitle': 'Dostosuj menu',
  'shell.customizeHelp': 'Wybierz, które strony mają się wyświetlać w menu bocznym. Ukryj te, których nie używasz, aby menu było przejrzyste.',
  'shell.customizeTitle': 'Dostosuj menu boczne',
  'shell.customizeVisible': 'Widoczne: {visible} z {total}',
  'shell.customizeLead': 'Wyłącz strony, których nie używasz, a zostaną ukryte w menu bocznym. Możesz je ponownie włączyć w dowolnym momencie.',
  'shell.customizeAllPages': 'Wszystkie strony',
  'shell.customizeAiMode': 'Tryb AI',
  'shell.customizeAlwaysOn': 'Zawsze włączone',
  'shell.customizeDone': 'Gotowe',
  'shell.camCapture': 'Zrób zdjęcie dokumentu',
  'shell.camHelp': 'Zrób zdjęcie dokumentu aparatem i wczytaj je bezpośrednio do skrzynki odbiorczej lub jako nowy zakup.',
  'shell.moreOptions': 'Więcej opcji',
  'shell.search': 'Szukaj',
  'shell.searchAll': 'Szukaj wszędzie',
  'shell.searchHelp': 'Szukaj w aktywnej firmie — klienci, faktury, produkty, dokumenty, projekty, strony i pomoc. Dotknij, aby otworzyć wyszukiwanie (skrót: Ctrl/⌘+K).',
  'shell.searchPlaceholderLong': 'Szukaj wszędzie — faktury, klienci, dokumenty…',
  'shell.searchEnterHint': 'aby zobaczyć wszystkie wyniki',
  'shell.companyHelpTitle': 'Wybierz firmę lub pracodawcę',
  'shell.companyHelp': 'Przełączaj się między prowadzonymi księgami a pracodawcami, u których jesteś zatrudniony. Wszystko w aplikacji dotyczy wybranej firmy.',
  'shell.yearHelpTitle': 'Rok obrotowy',
  'shell.yearHelp': 'Wybierz rok obrotowy, nad którym pracujesz. Wszystkie liczby i zgłoszenia dotyczą wybranego roku.',
  'shell.theme.helpTitle': 'Jasny / ciemny motyw',
  'shell.theme.help': 'Przełączaj między jasnym i ciemnym wyglądem w całej aplikacji. Wybór zostanie zapamiętany.',
  'shell.theme.toLight': 'Przełącz na jasny motyw',
  'shell.theme.toDark': 'Przełącz na ciemny motyw',
  'shell.theme.light': 'Jasny motyw',
  'shell.theme.dark': 'Ciemny motyw',
  'shell.bg.label': 'Kolor tła',
  'shell.bg.title': 'Kolor tła tej strony',
  'shell.bg.help': 'Wybierz kolor tła tylko dla tej strony. Kolor jest zapisywany dla każdej strony osobno.',
  'shell.bg.menuTitle': 'Kolor tła · ta strona',
  'shell.bg.default': 'Śliwka',
  'shell.bg.mint': 'Mięta',
  'shell.bg.varm': 'Ciepły',
  'shell.bg.sky': 'Niebieski',
  'shell.bg.rose': 'Róż',
  'shell.bg.skog': 'Las',
  'skin.title': 'Wygląd',
  'skin.standard': 'Standardowy',
  'skin.standardSub': 'Plumme',
  'skin.klassisk': 'Klasyczny',
  'skin.klassiskSub': 'Stonowany',
  'shell.client.employers': 'Twoi pracodawcy',
  'shell.client.employer': 'Pracodawca',
  'shell.client.employee': 'Pracownik',
  'shell.client.private': 'Prywatne',
  'shell.client.firm': 'Biuro rachunkowe',
  'shell.client.firmSub': 'Przegląd klientów i uzgodnienia',
  'rf.firm': 'Biuro rachunkowe',
  'rf.role.owner': 'Właściciel',
  'rf.role.admin': 'Administrator',
  'rf.role.employee': 'Współpracownik',
  'rf.group.firm': 'Księgowy',
  'rf.group.team': 'Czat zespołu',
  'rf.group.other': 'Pozostałe',
  'rf.nav.clients': 'Przegląd klientów',
  'rf.nav.reconciliation': 'Uzgodnienia',
  'rf.nav.control': 'Kontrola',
  'rf.nav.teamchat': 'Czat zespołu',
  'rf.nav.members': 'Współpracownicy',
  'rf.nav.clientList': 'Klienci',
  'rf.client.pageBody': 'Połącz biuro z jego klientami i przydziel współpracowników do zleceń.',
  'rf.client.addTitle': 'Połącz z klientem',
  'rf.client.addBody': 'Klient musi mieć konto Plumme dla swojej firmy. Biuro uzyska dostęp dopiero po akceptacji klienta.',
  'rf.client.billedTo': 'Kto płaci',
  'rf.client.billedToClient': 'Klient płaci sam',
  'rf.client.billedToFirm': 'Płaci biuro',
  'rf.client.request': 'Wyślij prośbę',
  'rf.client.requesting': 'Wysyłanie …',
  'rf.client.requested': 'Prośba została wysłana do klienta',
  'rf.avst.noClient': 'Najpierw wybierz klienta',
  'rf.avst.allClients': 'Wszyscy klienci',
  'rf.avst.thisClient': 'Ten klient',
  'rf.avst.noClientBody': 'Uzgodnienie dotyczy jednego klienta naraz. Otwórz klienta z przeglądu klientów, a folder uzgodnień podąży za nim.',
  'rf.client.requestedMailFailed': 'Prośba została wysłana, ale nie udało się dostarczyć powiadomienia e-mail. Klient zobaczy ją przy następnym logowaniu.',
  'rf.client.requestedNoRecipient': 'Prośba została wysłana, ale firma nie ma właściciela ani administratora do powiadomienia. Skontaktuj się z klientem samodzielnie.',
  'rf.client.noneTitle': 'Brak klientów',
  'rf.client.noneBody': 'Połącz biuro z klientem za pomocą numeru organizacyjnego. Klient musi wyrazić zgodę, zanim uzyskacie dostęp.',
  'rf.client.pendingBody': 'Klient musi zaakceptować prośbę na swoim koncie Plumme. Do tego czasu nikt w biurze nie ma dostępu.',
  'rf.client.assignWho': 'Przydziel do zlecenia',
  'rf.client.assignPick': 'Wybierz współpracownika',
  'rf.client.assignRole': 'Rola w zleceniu',
  'rf.client.assign': 'Przydziel',
  'rf.client.assigned': 'Współpracownik został przydzielony do klienta',
  'rf.client.end': 'Zakończ zlecenie',
  'rf.client.ended': 'Zlecenie zostało zakończone',
  'rf.client.endConfirm': 'Zakończyć zlecenie dla {name}? Dostęp przyznany przez biuro współpracownikom zostanie jednocześnie cofnięty.',
  'fe.title': 'Biuro rachunkowe prosi o dostęp',
  'fe.theFirm': 'Biuro',
  'fe.body': 'Jeśli zaakceptujesz, współpracownicy przydzieleni przez biuro do zlecenia uzyskają dostęp do Twojej księgowości. Współpracę możesz zakończyć w dowolnym momencie.',
  'fe.billedToFirm': 'Biuro płaci za subskrypcję',
  'fe.billedToClient': 'Za subskrypcję płacisz sam',
  'fe.accept': 'Przyznaj dostęp',
  'fe.accepting': 'Akceptowanie …',
  'fe.accepted': '{firm} ma teraz dostęp do ksiąg.',
  'fe.decline': 'Odrzuć',
  'fe.declined': 'Prośba została odrzucona.',
  'fi.title': 'Zaproszono Cię jako współpracownika',
  'fi.theFirm': 'biuro',
  'fi.body': 'Zaproszenie daje Ci dostęp do samego biura. Dostęp do konkretnego klienta otrzymasz dopiero, gdy biuro przypisze Cię do zlecenia.',
  'fi.verifyFirst': 'Najpierw potwierdź swój adres e-mail. Wysłaliśmy nowy link potwierdzający.',
  'fi.accept': 'Dołącz',
  'fi.accepting': 'Dołączanie …',
  'fi.accepted': 'Jesteś teraz współpracownikiem w {firm}.',
  'fi.acceptFailed': 'Nie udało się przyjąć zaproszenia.',
});
